function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.5 14C27.5 15.9154 27.3754 17.2638 27.0203 18.4726C26.6665 19.6767 26.0743 20.7751 25.0909 22.1745C24.2848 23.3217 23.2319 24.6493 21.8511 26.3904C21.5372 26.7861 21.2064 27.2033 20.8577 27.6445C19.069 29.9078 16.8246 32.7867 14.0174 36.6275C10.6285 31.5914 7.93231 28.1865 5.87945 25.5942C5.0271 24.5178 4.28566 23.5815 3.65159 22.7266C2.53674 21.2236 1.75564 19.9769 1.24846 18.6463C0.743539 17.3217 0.5 15.8867 0.5 14C0.5 6.54416 6.54416 0.5 14 0.5C21.4558 0.5 27.5 6.54416 27.5 14Z",
  fill: "#807E78",
  stroke: "#676667"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 4.5,
  fill: "#FEFEFE",
  stroke: "#676667"
});
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 38,
    viewBox: "0 0 28 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.1e2720a416cb84f58713628e8da20fc5.svg";
export { ForwardRef as ReactComponent };